<nav class="navbar sticky-top">
  <div class="col-12 p-2 text-end">
    <div class="header-container">
      <div>
        <div *ngIf="!companyName" class="client-name-container">
          <div class="lines shine"></div>
          <div class="lines shine"></div>
        </div>
        <button *ngIf="companyName" class="btn btn-primary" (click)="openClientSelector()">
          {{ companyName }} {{ selectedCompanies?.length > 1 ? ' + ' + (selectedCompanies?.length - 1) : '' }}
        </button>
      </div>
      <div class="">
        <ul class="list-unstyled">
          <li class="dropdown ml-2">
            <a
              class="rounded-circle"
              tabindex="0"
              role="button"
              id="dropdownUser"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
              <div class="avatar avatar-md avatar-indicators avatar-online">
                <img alt="avatar" src="./assets/images/avatar-img.jpg" class="rounded-circle" />
              </div>
            </a>
            <div class="dropdown-menu pb-2" aria-labelledby="dropdownUser">
              <div class="">
                <ul class="list-unstyled">
                  <li><a class="dropdown-item" [routerLink]="DASHBOARD">Dashboard </a></li>
                  <li><a class="dropdown-item" [routerLink]="SETTINGS">Settings </a></li>
                  <li><a class="dropdown-item" (click)="logout()">Logout </a></li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
